import { Col, ColProps, Divider } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const StyledLoginCol = styled(Col)`
  &.has-background {
    background-color: ${props => props.theme.colorBgLayout};
    border-radius: ${props => props.theme.borderRadius}px;
  }
  ${down('lg')} {
    /* padding-bottom: 48px; */
  }
  flex: 1 1 100%;
  max-width: 100%;
  padding-top: 2px;
  padding-bottom: 2px;
  &.is-large {
    flex: 1 1 56%;
    max-width: 56%;
    ${down('xl')} {
      flex: 1 1 100%;
      max-width: 100%;
      padding-bottom: 24px;
    }
  }
  &.is-double {
    flex: 1 1 44%;
    max-width: 44%;
    padding-top: 0;
    padding-bottom: 0;
    ${down('xl')} {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }
`;

const H2Title = styled.h2`
  font-size: 1rem;
  margin-bottom: 0;
  font-weight: 700;
  &.sr-only {
    width: 100%;
    top: 50%;
  }
`;
const A11YDividerWrapper = styled.div`
  position: relative;
`;

export interface ILoginColProps extends ColProps {
  hasBackground?: boolean;
  isLarge?: boolean;
  isDouble?: boolean;
}
/**
 * Form di login all'applicativo, tramite le API di creazione AccessToken JWT.
 */
export function LoginCol(props: ILoginColProps) {
  const {
    title,
    children,
    hasBackground,
    className,
    isLarge,
    isDouble,
    ...colProps
  } = props;

  return (
    <StyledLoginCol
      {...colProps}
      className={clx(className, {
        'has-background': hasBackground,
        'is-large': isLarge,
        'is-double': isDouble,
      })}
    >
      {title && (
        <A11YDividerWrapper>
          <Divider aria-hidden="true">{title}</Divider>
          <H2Title className="sr-only">{title}</H2Title>
        </A11YDividerWrapper>
      )}
      <div>{children}</div>
    </StyledLoginCol>
  );
}
